import PageHead from "../Head";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Separator from "@/components/Common/Separator";
import MainDemo from "@/components/01-Main-Demo/01-Main-Demo";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";

import Context from "@/context/Context";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import FooterThree from "@/components/Footer/Footer-Three";

const Home = () => {
  return (
    <>
      <PageHead title="The Immigration Gurus"
        description="Study abroad with The Immigration Gurus — expert counselling on universities, courses, applications and student visas for Indian students." />

      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <MainDemo />
          <Cart />

          <Separator />
          <FooterThree />
        </Context>
      </Provider>
    </>
  );
};

export default Home;
export async function getServerSideProps() {
  try {
    // Static data (you can replace this with API calls or dynamic data)
    const result_data = {
      name: "John Doe",
      country: "USA",
      occupation: "Software Developer",
    };

    return {
      props: {
        result_data, // Passing static data as props to the component
      },
    };
  } catch (err) {
    console.error("Error:", err); // Log any error that occurs during data fetching
    return {
      notFound: true, // Gracefully handle any errors
    };
  }
}
